module.exports = __webpack_public_path__ + "img/listedsnakes.950a1356.png";